import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";

/**
 * Full-screen maintenance page shown when the Kill Switch is active.
 * Polls /api/killswitch/status every 30s so the page auto-recovers
 * once the admin disables maintenance mode.
 */
export default function Maintenance({ message }) {
  const [msg, setMsg] = useState(message || "ShiftQuote is undergoing maintenance. We'll be back shortly.");
  const [dots, setDots] = useState("");

  // Animate dots
  useEffect(() => {
    const id = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 600);
    return () => clearInterval(id);
  }, []);

  // Poll for recovery
  useEffect(() => {
    const poll = setInterval(async () => {
      try {
        const res = await fetch("/api/killswitch/status");
        const data = await res.json();
        if (!data.maintenance) {
          window.location.reload();
        }
        if (data.message) setMsg(data.message);
      } catch {
        // ignore network errors during maintenance
      }
    }, 30000);
    return () => clearInterval(poll);
  }, []);

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-6 animate-pulse">
        <Wrench className="w-8 h-8 text-amber-400" />
      </div>
      <h1 className="text-2xl font-bold text-white mb-3">Under Maintenance</h1>
      <p className="text-zinc-400 max-w-md leading-relaxed mb-6">{msg}</p>
      <div className="flex items-center gap-2 text-zinc-500 text-sm">
        <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
        <span>Checking status{dots}</span>
      </div>
    </div>
  );
}
